/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CsvError } from "./CsvError";
import type { CsvImportSuccess } from "./CsvImportSuccess";
export type CsvImportOutcome = {
  details: CsvImportSuccess;
  kind: CsvImportOutcome.kind;
} | {
  details: CsvError;
  kind: CsvImportOutcome.kind;
};
export namespace CsvImportOutcome {
  export enum kind {
    SUCCESS = "success",
  }
}
